import React from 'react';
import GiftTopSvg from '../../assets/gift-top.svg';
import '../../scss/components/GiftsPage/GiftCard.scss';

const GiftCard = ({ gift, index }) => {
    const { description, name } = gift;

    return (
        <div
            className="gift-item-card"
            style={{ animationDelay: `${0.5 * (index + 1)}s` }}
        >
            <div className="gift-title-badge">
                <img src={GiftTopSvg} alt="" />
                <span className="badge-text">Подарок</span>
            </div>
            <div className="gift-background">
                <div className="background-rect"></div>
                <svg className="corner top-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 2H13.6364L2 12.2655V31" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner top-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2H36.3636L48 12.2655V31" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 48H13.6364L2 37.7345V19" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 48H36.3636L48 37.7345V19" stroke="#E9F7FA" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
            </div>
            <div className="gift-card-content">
                <div className="gift-item-name">
                    <span className="gift-name">{name || "Подарок"}</span>
                </div>
                <div className="gift-item-description">{description}</div>
            </div>
        </div>
    );
};

export default GiftCard; 